<template>
    <v-container fluid>
      <v-row>
        <!-- Active Employees Card -->
        <v-col cols="12" md="6">
          <v-card class="rounded-xl elevation-4">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-account-check</v-icon>
              <span class="headline font-weight-bold">{{ descricaoFuncionario }} Ativos</span>
              <v-spacer />
              <v-text-field
                v-model="searchAtivos"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
                dark
                clearable
              />
            </v-card-title>
            
            <v-data-table
              :headers="headers"
              :items="listaFuncionariosAtivos"
              :search="searchAtivos"
              :no-data-text="'Nenhum ' + descricaoFuncionario.toLowerCase() + ' ativo encontrado'"
              class="elevation-1"
            >
              <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-center">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        color="primary"
                        v-on="on"
                        @click="alterarDadosFuncionario(item)"
                        class="mx-1"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar dados</span>
                  </v-tooltip>
                  
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        color="error"
                        v-on="on"
                        @click="desativarFuncionario(item)"
                        class="mx-1"
                      >
                        <v-icon>mdi-account-remove</v-icon>
                      </v-btn>
                    </template>
                    <span>Desativar</span>
                  </v-tooltip>
                </div>
              </template>
              
              <template v-slot:no-results>
                <v-alert
                  :value="true"
                  color="warning"
                  icon="mdi-alert"
                  class="my-4"
                >
                  Nenhum resultado encontrado para "{{ searchAtivos }}"
                </v-alert>
              </template>
            </v-data-table>
          </v-card>
        </v-col>

        <!-- Inactive Employees Card -->
        <v-col cols="12" md="6">
          <v-card class="rounded-xl elevation-4">
            <v-card-title class="secondary white--text">
              <v-icon left color="white">mdi-account-off</v-icon>
              <span class="headline font-weight-bold">{{ descricaoFuncionario }} Inativos</span>
              <v-spacer />
              <v-text-field
                v-model="searchDesativos"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
                dark
                clearable
              />
            </v-card-title>
            
            <v-data-table
              :headers="headersDesativo"
              :items="listaFuncionariosDesativos"
              :search="searchDesativos"
              :no-data-text="'Nenhum ' + descricaoFuncionario.toLowerCase() + ' inativo encontrado'"
              class="elevation-1"
            >
              <template v-slot:item.actions="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      color="success"
                      v-on="on"
                      @click="ativarFuncionario(item)"
                    >
                      <v-icon>mdi-account-reactivate</v-icon>
                    </v-btn>
                  </template>
                  <span>Reativar</span>
                </v-tooltip>
              </template>
              
              <template v-slot:no-results>
                <v-alert
                  :value="true"
                  color="warning"
                  icon="mdi-alert"
                  class="my-4"
                >
                  Nenhum resultado encontrado para "{{ searchDesativos }}"
                </v-alert>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'FuncionariosLista',
  props: {
    listaFuncionariosAtivos: {
      type: Array,
      required: true,
      default: () => []
    },
    listaFuncionariosDesativos: {
      type: Array,
      required: true,
      default: () => []
    },
    descricaoFuncionario: {
      type: String,
      required: true,
      default: 'Funcionário'
    },
    tipoFuncionario: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      searchAtivos: '',
      searchDesativos: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          sortable: true,
          value: 'nome',
          class: 'primary--text font-weight-bold'
        },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: '150px',
          class: 'primary--text font-weight-bold'
        }
      ],
      headersDesativo: [
        {
          text: 'Nome',
          align: 'start',
          sortable: true,
          value: 'nome',
          class: 'secondary--text font-weight-bold'
        },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: '100px',
          class: 'secondary--text font-weight-bold'
        }
      ]
    };
  },
  methods: {
    alterarDadosFuncionario(item) {
      this.$emit('alterar-dados-funcionario', item, this.tipoFuncionario);
    },
    desativarFuncionario(item) {
      this.$emit('desativar-funcionario', item, this.tipoFuncionario);
    },
    ativarFuncionario(item) {
      this.$emit('ativar-funcionario', item, this.tipoFuncionario);
    }
  }
};
</script>

<style scoped>
.rounded-xl {
  border-radius: 16px !important;
}

.v-card__title {
  border-top-left-radius: 16px !important;
  border-top-right-radius: 16px !important;
}

.v-btn {
  transition: all 0.3s ease;
}

.v-btn:hover {
  transform: scale(1.1);
}

.v-data-table >>> thead tr th {
  font-size: 1rem !important;
  background-color: #f5f5f5;
}
</style>